export default function parseAddress(place) {
  var componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
  };

  var address = {

  };

  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    if (componentForm[addressType]) {
      var val = place.address_components[i][componentForm[addressType]];
      if (!val) {
        val = '';
      }
      address[addressType] = val;
    } else {
      address[addressType] = '';
    }

  }

  if (!address.street_number) {
    address.street_number = ''
  }

  if (!address.route) {
    address.route = ''
  }

  if (!address.postal_code) {
    address.postal_code = ''
  }

  if (!address.locality) {
    address.locality = ''
  }

  if (!address.administrative_area_level_1) {
    address.administrative_area_level_1 = ''
  }

  return (address);
}



// WEBPACK FOOTER //
// ./src/api/AddressParser.js